// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"NoteSearchBox_searchBox__2n2ea","searchInput":"NoteSearchBox_searchInput__22Vf2","sortIcon":"NoteSearchBox_sortIcon__1Tdak"};